import PropTypes from 'prop-types'
import { memo, useContext } from 'react'
import { TableContext } from 'components/table/Table'
import { isEmpty } from 'utils'

const Body = memo(({ children = [] }) => {
  const {
    columns,
    rows,
    error,
    loading,
    emptyMessage,
    errorMessage,
    mergeHeadersOnNoContent,
  } = useContext(TableContext)

  return (
    <tbody style={!error && loading ? { opacity: 0.5 } : {}}>
      {(error && (
        <tr>
          <td
            colSpan={mergeHeadersOnNoContent ? 1 : columns.length}
            className="nodata_info">
            <div className="inner_tbl">{errorMessage}</div>
          </td>
        </tr>
      )) ||
        (isEmpty(rows) && (
          <tr>
            <td
              colSpan={mergeHeadersOnNoContent ? 1 : columns.length}
              className="nodata_info">
              <div className="inner_tbl">{!loading && emptyMessage}</div>
            </td>
          </tr>
        ))}
      {children}
    </tbody>
  )
})

export default Body

Body.displayName = 'Body'
Body.propTypes = {
  children: PropTypes.node,
}
